"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PYSPARK_NOTEBOOK = exports.SPARK_NOTEBOOK = exports.PYTHON3_NOTEBOOK = void 0;
exports.PYTHON3_NOTEBOOK = 'python3';
exports.SPARK_NOTEBOOK = 'spark';
exports.PYSPARK_NOTEBOOK = 'pyspark';
//# sourceMappingURL=notebookTypes.js.map